import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";

const ViewDetailSetting = ({ setViewDetail, selectedData }) => {

  const getId = (id) => {
    if (id) {
      return <PropertyId>#{id}</PropertyId>;
    } else {
      return <Unverified>N/A</Unverified>;
    }
  };

  return (
    <Model width={`w-11/12 max-w-2xl `} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
          <Status>
            {getId(selectedData?.id) || "N/A"}
            </Status>
            {/* <Status className="ml-3">
            {getStatus(selectedData?.status) || "N/A"}
          </Status> */}
        </div>
            <Column>
          <FirstColumn>
          <SubHeading>IOS</SubHeading>
          <Paragraph>{selectedData?.ios || "N/A"}</Paragraph>
          </FirstColumn>
           <SecondColumn>
            <SubHeading>Android</SubHeading>
            <Paragraph>{selectedData?.android || "N/A"}</Paragraph>
          </SecondColumn> 
        </Column>
      </Wrapper>
    </Model>
  );
};

const Status = tw.div``;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
const Unverified = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;

export default ViewDetailSetting;